//Others
import { Storage } from "aws-amplify";

//main function
export async function removeImagePromise(key, config) {
    return new Promise((resolve, reject) => {
      Storage.remove(key, config).then(resolve).catch(reject);
    });
  }